import cssVars from 'css-vars-ponyfill';
document.addEventListener("turbolinks:load", () => {
  cssVars({
    watch: true,
    silent: true
  })
})
